/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import BASE_REPORT from '../BaseComponent/BASEREPORT'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import HeaderGrid from '../Pagination/HeaderGrid'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'

class Province extends React.Component {
  constructor(props) {
    super(props)
    // this.state = {
    //   Province: [],
    //   lengthProducts: 0,
    //   pageNumber: 1,
    //   pageSize: 10,
    //   sortBy: "",

    //   printInfo: []
    // };
    this.state = {
      Province: [],
      printInfo: [],
      lengthProducts: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      modalDelete: false,
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام استان',
          value: 'provinceName',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'عرض جغرافیایی',
          value: 'latitude',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'طول جغرافیایی',
          value: 'longitude',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت فعال',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  getAllProvince = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    http
      .get(`${BASE_REPORT.BASE_REPORT_PROVINCE}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable').fadeIn()
          if (!exportStatus) {
            this.setState({
              Province: response.data.object.result,
              lengthProducts: response.data.object.countAll
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result
            })
          }
        } else {
          $('.showBaseTable').fadeOut()
        }
      })
    //   .catch(error => {
    //     // alert(JSON.stringify(error))
    //   });
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    this.getAllProvince(false)
  }

  activate = (numRow) => {
    let status = this.state.Province[numRow].enabled
    if (status) {
      let id = this.state.Province[numRow].provinceId
      let data = {
        id: id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DISABLE_PROVINCE}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllProvince(false)
          } else {
            // message.error("عملیات تغییر وضعیت استان موفق نبود");
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let id = this.state.Province[numRow].provinceId
      let data = {
        id: id
      }
      const token = sessionStorage.getItem('accessToken')

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_ENABLE_PROVINCE}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllProvince(false)
          } else {
            // message.error("عملیات تغییر وضعیت استان موفق نبود");
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deleteProvince = (numId) => {
    sessionStorage.setItem('selectedRow', numId)

    let provinceId = this.state.Province[numId].provinceId
    let provinceName = this.state.Province[numId].name
    sessionStorage.setItem('provinceId', provinceId)
    sessionStorage.setItem('provinceName', provinceName)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('provinceId')
    sessionStorage.removeItem('provinceName')
  }

  deleteOk = () => {
    var selectedRow = sessionStorage.getItem('selectedRow')
    const token = sessionStorage.getItem('accessToken')

    let cityId = sessionStorage.getItem('provinceId')
    let data = {
      id: cityId
    }
    http
      .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DELETE_PROVINCE}`, data, {})
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          message.success('استان با موفقیت حذف شد')

          this.state.Province.splice(selectedRow, 1)
          this.setState(this.state.Province)
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  onResultFetched(data) {
    this.setState({
      Province: data
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAllProvince(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAllProvince(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAllProvince(false)
    }
  }

  changeDropDown(data) {
    this.setState({
      Province: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let name = $('#name').val()
    let latitude_min = $('#latitude_min').val()
    let latitude_max = $('#latitude_max').val()
    let longitude_max = $('#longitude_max').val()
    let longitude_min = $('#longitude_min').val()
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (name !== '' && name.length) {
      filter.name = name
    }
    if (latitude_max !== '' && latitude_max.length) {
      filter.latitude_max = latitude_max
    }
    if (latitude_min !== '' && latitude_min.length) {
      filter.latitude_min = latitude_min
    }
    if (longitude_max !== '' && longitude_max.length) {
      filter.longitude_max = longitude_max
    }
    if (longitude_min !== '' && longitude_min.length) {
      filter.longitude_min = longitude_min
    }
    return filter
  }

  filter() {
    this.getAllProvince(false)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${BASE_REPORT.BASE_REPORT_PROVINCE}`, {
        params: filter
      })
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          this._export.save(this.state.excelReport)
        }
      })
  }

  getPrintInfo = () => {
    this.getAllProvince(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let {pageNumber, pageSize} = this.state
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    const provinceName = sessionStorage.getItem('provinceName')

    let name = cookie.load('name')
    let columns = ['ردیف', 'نام', 'عرض جغرافیایی', 'طول جغرافیایی']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست استان ها"
              headerColSpan={4}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />

            <tbody>
              {this.state.printInfo.map((province, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{province.name}</td>
                  <td>{province.latitude}</td>
                  <td>{province.longitude}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست استان ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'name'}
                field={'name'}
                title={'نام'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'latitude'}
                field={'latitude'}
                title={'عرض جغرافیایی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'longitude'}
                field={'longitude'}
                title={'طول جغرفیایی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>لیست استان ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/addProvince'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>

                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نام</label>
                  <input className="form-control" id="name" type="text" />
                </div>
                <div className="formComponent">
                  <label>عرض جغرافیایی از</label>
                  <input className="form-control" id="latitude_min" type="number" />
                </div>
                <div className="formComponent">
                  <label>عرض جغرافیایی تا</label>
                  <input className="form-control" id="latitude_max" type="number" />
                </div>

                <div className="formComponent">
                  <label>طول جغرافیایی از</label>
                  <input className="form-control" id="longitude_min" type="number" />
                </div>
                <div className="formComponent">
                  <label>طول جغرافیایی تا</label>
                  <input className="form-control" id="longitude_max" type="number" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.Province.map((province, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{province.name}</td>
                      <td>{province.latitude}</td>
                      <td>{province.longitude}</td>
                      <td>
                        <button onClick={() => this.activate(index)}>
                          {province.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <Link to={`editProvince/${province.provinceId}`}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <button onClick={() => this.deleteProvince(index)}>
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthProducts}
                />
              </div>
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
            <ModalHeader toggle={this.deleteCancel}>حذف استان</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف استان {provinceName} مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف استان
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
              {/*<Button color="primary" onClick={this.deleteOk}>حذف استان</Button>*/}
              {/*<Button color="danger" onClick={this.deleteCancel}>لغو</Button>{' '}*/}
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default Province
